import { ImageSection } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { useTranslation } from '@frontend/i18n';
import { FieldChangeEvent } from '@frontend/design-system';
import { useComposerSection } from '../../content-composer/hooks/use-composer-section';
import { useSettingsForm } from '../../content-composer/hooks/use-settings-form';
import { CountSetting } from '../../content-composer/settings-atoms/count-setting';
import { FrameSetting } from '../../content-composer/settings-atoms/frame-setting';
import { ImageSetting } from '../../content-composer/settings-atoms/image-setting';
import { PaddingSetting } from '../../content-composer/settings-atoms/padding-setting';
import { SettingsPanel } from '../../content-composer/settings-panel/settings-panel';
import { convertValueToPixels } from '../../content-composer/utils/convert-value-to-pixels';

export const ImageSettings = () => {
  const { t } = useTranslation('content-composer');
  const { props } = useComposerSection<ImageSection>();

  const { getFieldProps } = useSettingsForm<ImageSection>({
    corners: { type: 'radio' },
    frame: {
      alignment: { type: 'radio' },
      backgroundColor: { type: 'text' },
      paddingTop: { type: 'text' },
      paddingBottom: { type: 'text' },
      paddingLeft: { type: 'text' },
      paddingRight: { type: 'text' },
    },
    height: { type: 'text' },
    imageCount: { type: 'radio' },
    imageSpacing: { type: 'text' },
  });

  const imageSpacingFieldProps = getFieldProps('imageSpacing');

  return (
    <SettingsPanel>
      <SettingsPanel.Header>{t('Image')}</SettingsPanel.Header>
      <SettingsPanel.Body>
        <CountSetting {...{ ...getFieldProps('imageCount'), value: (props.imageCount || 1).toString() }} />
        <ImageSetting cornersFieldProps={getFieldProps('corners')} heightFieldProps={getFieldProps('height')} />
        <FrameSetting {...getFieldProps('frame', 'backgroundColor')} />
        <PaddingSetting
          paddingTopFieldProps={getFieldProps('frame', 'paddingTop')}
          paddingBottomFieldProps={getFieldProps('frame', 'paddingBottom')}
          paddingLeftFieldProps={getFieldProps('frame', 'paddingLeft')}
          paddingRightFieldProps={getFieldProps('frame', 'paddingRight')}
          imageSpacingFieldProps={{
            ...imageSpacingFieldProps,
            value: convertValueToPixels(props.imageSpacing),
            disabled: Number(props.imageCount) < 2,
            onChange: (e: FieldChangeEvent) => {
              // @ts-expect-error design system type is wrong
              const pixelValue = e.value;
              const numericValue = parseInt(pixelValue, 10);
              if (!isNaN(numericValue)) {
                imageSpacingFieldProps.onChange({ ...imageSpacingFieldProps, value: numericValue });
              } else {
                imageSpacingFieldProps.onChange(e);
              }
            },
          }}
        />
      </SettingsPanel.Body>
    </SettingsPanel>
  );
};
